import { i18n } from "../src/plugins/i18n";

const content = {
  device_evm_table: [
    {
      align: "start",
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.deviceId.text",
      ),
      value: "DeviceID",
      sortable: true,
      of_type: "modal",
      identifier: "DeviceID",
      url: "/asset/",
    },
    {
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.maxEVs.text",
      ),
      value: "MaxEVs",
      of_type: "text",
    },
    {
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.maxEVHour.text",
      ),
      value: "MaxEVsHour",
      of_type: "text",
    },
    {
      text: "Max HPs",
      value: "MaxHPs",
      of_type: "text",
    },
    {
      text: "Max HP Hour",
      value: "MaxHPsHour",
      of_type: "text",
    },
    {
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.firstYearOverCapacity.text",
      ),
      value: "FirstYearOverCapacity",
      of_type: "text",
    },
    {
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.maxLoadDay.text",
      ),
      value: "MaxLoadDay",
      of_type: "date",
    },
    {
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.minHeadroom.text",
      ),
      value: "MinHeadroom",
      of_type: "text",
    },
    {
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.maxLoad.text",
      ),
      value: "MaxLoad",
      of_type: "text",
    },
    {
      text: i18n.t(
        "views.EVModelling.tables.deviceEVMTable.columns.maxLoadHour.text",
      ),
      value: "MaxLoadHour",
      of_type: "text",
    },
  ],
};

export { content };
